import { render, staticRenderFns } from "./login-email.html?vue&type=template&id=4bbce93d&scoped=true&"
import script from "./login-email.js?vue&type=script&lang=js&"
export * from "./login-email.js?vue&type=script&lang=js&"
import style0 from "./login-email.scss?vue&type=style&index=0&id=4bbce93d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbce93d",
  null
  
)

export default component.exports